"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = (function (virtual) { return function (frame) {
    var params = frame.params;
    // 回复响应帧
    virtual.send('appSendResp', params);
    var data = params && params.data ? params.data : {};
    var decode = virtual.decode(data);
    var cmds = virtual.protocol.cmds;
    /**
     * JSON_TRANSPARENT_NOT_CHECK_RAW协议
     * 就直接返回data
     */
    if (virtual.device.workModeType === 'JSON_TRANSPARENT_NOT_CHECK_RAW') {
        // 模拟网络延迟
        setTimeout(function () {
            // 上报帧
            virtual.send('devSend', { data: data });
        }, virtual.options.delay);
        return;
    }
    // 添加关联的上报帧到[[QUEUE]]
    if (decode.cmdId !== undefined) {
        var associateProtocol = cmds[decode.cmdId].associateProtocol;
        associateProtocol.forEach(function (cmdId) { return virtual['[[QUEUE]]'].add(cmdId); });
    }
    // 更新设备状态
    virtual.setState(decode);
    // 发送队列中的上报帧
    virtual['[[QUEUE]]'].forEach(function (cmdId) {
        var fields = cmds[cmdId].fields;
        var state = { cmdId: cmdId };
        fields.forEach(function (field) {
            state[field] = virtual.state[field];
        });
        // 模拟网络延迟
        setTimeout(function () {
            // 上报帧
            virtual.send('devSend', { data: state });
        }, virtual.options.delay);
    });
    virtual['[[QUEUE]]'].clear();
}; });



// WEBPACK FOOTER //
// ./src/actions/receive/actions/appSend.ts